import { useEffect, useRef } from 'react';
import { useAuth } from './AuthContext';
import { genresOf } from './discoveryModel';

export default function useViewingSession(active,item,mediaType,playerRef){
  const {user,saveExperienceItem}=useAuth();
  const userId=user?.uid;
  const itemId=item?.id;
  const latest=useRef({item,saveExperienceItem});latest.current={item,saveExperienceItem};
  useEffect(()=>{
    if(!active || !userId || !latest.current.item)return;
    const metadata=latest.current.item;
    const sessionId=window.crypto?.randomUUID ? window.crypto.randomUUID():`${Date.now()}_${Math.random().toString(36).slice(2)}`;
    const startedAt=Date.now();let last=startedAt,seconds=0,estimated=false,visible=document.visibilityState==='visible',nativePip=false;
    const save=()=>{
      const now=Date.now(),elapsed=Math.max(0,Math.min(35,(now-last)/1000));last=now;
      const video=playerRef.current?.querySelector('video');
      if(video){if(!video.paused&&!video.ended)seconds+=elapsed;}else if(visible || nativePip){seconds+=elapsed;estimated=true;}
      if(seconds<1)return;
      latest.current.saveExperienceItem('sessions',sessionId,{id:metadata.id,mediaType,title:metadata.title || metadata.name,startedAt,endedAt:now,seconds:Math.round(seconds),estimated,genreIds:genresOf(metadata),actors:(metadata.credits?.cast || []).slice(0,5).map(a=>a.name)}).catch(()=>{});
    };
    const timer=setInterval(save,30000);
    const visibility=()=>{save();visible=document.visibilityState==='visible';};
    const pip=event=>{save();nativePip=!!(event.detail?.active ?? event.active);};
    window.addEventListener('pagehide',save);
    window.addEventListener('hedonePipChanged',pip);
    document.addEventListener('visibilitychange',visibility);
    return()=>{clearInterval(timer);window.removeEventListener('pagehide',save);window.removeEventListener('hedonePipChanged',pip);document.removeEventListener('visibilitychange',visibility);save();};
  },[active,userId,itemId,mediaType,playerRef]);
}
